/* Paramedic Flash reviews: renders the product review widget and the
   "Real customer stories" carousel from the JSON files in assets/
   (pf-reviews-<handle>.json, pf-reviews-stories.json). No outside app. */
(function () {
  if (window.__pfReviews) return;
  window.__pfReviews = true;

  var STAR = '<svg class="pfr-star" viewBox="2.2 2.2 19.6 19.6" aria-hidden="true"><path fill="currentColor" d="M12 2.5l2.94 6.26 6.86.78-5.1 4.68 1.4 6.78L12 17.6 5.9 21l1.4-6.78-5.1-4.68 6.86-.78z"/></svg>';
  var STAR_EMPTY = '<svg class="pfr-star" viewBox="2.2 2.2 19.6 19.6" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" d="M12 3.6l2.6 5.6 6.1.7-4.5 4.2 1.2 6L12 17.1l-5.4 3 1.2-6-4.5-4.2 6.1-.7z"/></svg>';
  var CHEV_R = '<svg viewBox="0 0 14 24" aria-hidden="true"><path d="M2 2l10 10L2 22" fill="none" stroke="currentColor" stroke-width="2"/></svg>';
  var CHEV_L = '<svg viewBox="0 0 14 24" aria-hidden="true"><path d="M12 2L2 12l10 10" fill="none" stroke="currentColor" stroke-width="2"/></svg>';
  var CHEV_D = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 4l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';
  var CHECK = '<svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="8" fill="#fff"/><path d="M4.5 8.2l2.3 2.3 4.7-4.8" fill="none" stroke="#000" stroke-width="1.6"/></svg>';

  function stars(n) {
    var s = '';
    for (var i = 1; i <= 5; i++) s += i <= n ? STAR : STAR_EMPTY;
    return '<span class="pfr-stars" role="img" aria-label="' + n + ' out of 5 stars">' + s + '</span>';
  }
  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function img(url, w) {
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function fetchJSON(url) {
    return fetch(url, { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }
  function verifiedTag(v) {
    if (v === 'shop') return '<span class="pfr-verified pfr-verified--shop">Verified by Shop</span>';
    if (v) return '<span class="pfr-verified">Verified</span>';
    return '';
  }

  /* ---------- one shared popup for photos and stories ---------- */
  var modal, modalList = [], modalIdx = 0;
  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'pfr pfr-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML =
      '<div class="pfr-modal__box">' +
      '<button class="pfr-modal__close" type="button" aria-label="Close">&times;</button>' +
      '<div class="pfr-modal__img"></div><div class="pfr-modal__text"></div>' +
      '<button class="pfr-modal__nav pfr-modal__nav--prev" type="button" aria-label="Previous">' + CHEV_L + '</button>' +
      '<button class="pfr-modal__nav pfr-modal__nav--next" type="button" aria-label="Next">' + CHEV_R + '</button>' +
      '</div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('.pfr-modal__close')) closeModal();
      else if (e.target.closest('.pfr-modal__nav--prev')) showModal(modalIdx - 1);
      else if (e.target.closest('.pfr-modal__nav--next')) showModal(modalIdx + 1);
    });
    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowLeft') showModal(modalIdx - 1);
      if (e.key === 'ArrowRight') showModal(modalIdx + 1);
    });
    return modal;
  }
  function openModal(list, idx) {
    ensureModal();
    modalList = list;
    showModal(idx);
    modal.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeModal() {
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }
  function showModal(i) {
    if (!modalList.length) return;
    modalIdx = (i + modalList.length) % modalList.length;
    var item = modalList[modalIdx], r = item.review;
    modal.querySelector('.pfr-modal__img').innerHTML = '<img src="' + esc(img(item.url, 1200)) + '" alt="Photo from ' + esc(r.n) + '">';
    modal.querySelector('.pfr-modal__text').innerHTML =
      stars(r.r) +
      '<div class="pfr-card__who"><div class="pfr-card__name-row"><span class="pfr-card__name">' + esc(r.n) + '</span>' + verifiedTag(r.v) + '</div>' +
      '<span class="pfr-card__date">' + esc(r.d) + '</span></div>' +
      (r.t ? '<p class="pfr-card__title">' + esc(r.t) + '</p>' : '') +
      '<p class="pfr-card__body">' + esc(r.b) + '</p>';
    var multi = modalList.length > 1;
    modal.querySelector('.pfr-modal__nav--prev').hidden = !multi;
    modal.querySelector('.pfr-modal__nav--next').hidden = !multi;
  }
  function photosOf(reviews) {
    var out = [];
    reviews.forEach(function (r) {
      (r.p || []).forEach(function (p) { out.push({ url: p[0], review: r }); });
    });
    return out;
  }

  /* ---------- product review widget ---------- */
  var PER_PAGE = 10;
  function initWidget(root) {
    var body = root.querySelector('.pfr-body');
    var grid = root.querySelector('.pfr-grid');
    var moreBtn = root.querySelector('.pfr-more');
    var stripTrack = root.querySelector('.pfr-strip__track');
    var all = [], view = [], shown = 0, peeking = true, sort = 'recent', starFilter = 0;

    fetchJSON(root.getAttribute('data-src')).then(function (data) {
      all = data.reviews || [];
      buildStrip();
      buildBars(data);
      apply();
    }).catch(function () { root.hidden = true; });

    function buildStrip() {
      var photos = photosOf(all);
      var strip = root.querySelector('.pfr-strip');
      if (!photos.length) { strip.hidden = true; return; }
      stripTrack.innerHTML = photos.map(function (p, i) {
        return '<button class="pfr-strip__item" type="button" data-i="' + i + '" aria-label="Open photo from ' + esc(p.review.n) + '">' +
          '<img src="' + esc(img(p.url, 200)) + '" alt="" loading="lazy" width="100" height="100"></button>';
      }).join('');
      stripTrack.addEventListener('click', function (e) {
        var b = e.target.closest('.pfr-strip__item');
        if (b) openModal(photos, +b.getAttribute('data-i'));
      });
      var prev = root.querySelector('.pfr-strip__arrow--prev'), next = root.querySelector('.pfr-strip__arrow--next');
      function arrows() {
        prev.hidden = stripTrack.scrollLeft < 4;
        next.hidden = stripTrack.scrollLeft + stripTrack.clientWidth >= stripTrack.scrollWidth - 4;
      }
      prev.addEventListener('click', function () { stripTrack.scrollLeft -= stripTrack.clientWidth * 0.8; });
      next.addEventListener('click', function () { stripTrack.scrollLeft += stripTrack.clientWidth * 0.8; });
      stripTrack.addEventListener('scroll', arrows, { passive: true });
      window.addEventListener('resize', arrows);
      arrows();
    }

    function buildBars(data) {
      var box = root.querySelector('.pfr-filters__bars');
      var total = data.count || 1, html = '';
      for (var s = 5; s >= 1; s--) {
        var n = (data.hist && data.hist[s]) || 0;
        html += '<button type="button" class="pfr-bar" data-star="' + s + '"' + (n ? '' : ' disabled') + '>' + stars(s) +
          '<span class="pfr-bar__track"><span class="pfr-bar__fill" style="width:' + Math.round((n / total) * 100) + '%"></span></span>' +
          '<span>' + n + '</span></button>';
      }
      box.innerHTML = html;
      box.addEventListener('click', function (e) {
        var b = e.target.closest('.pfr-bar');
        if (!b) return;
        var s = +b.getAttribute('data-star');
        starFilter = starFilter === s ? 0 : s;
        box.querySelectorAll('.pfr-bar').forEach(function (x) { x.classList.toggle('is-active', +x.getAttribute('data-star') === starFilter); });
        apply();
      });
      root.querySelector('.pfr-filters__clear').addEventListener('click', function () {
        starFilter = 0;
        box.querySelectorAll('.pfr-bar').forEach(function (x) { x.classList.remove('is-active'); });
        apply();
      });
    }

    function apply() {
      view = all.filter(function (r) {
        if (starFilter && r.r !== starFilter) return false;
        if (sort === 'pictures' && !(r.p && r.p.length)) return false;
        return true;
      });
      var byDate = function (a, b) { return b.ts - a.ts; };
      if (sort === 'highest') view.sort(function (a, b) { return b.r - a.r || byDate(a, b); });
      else if (sort === 'lowest') view.sort(function (a, b) { return a.r - b.r || byDate(a, b); });
      else if (sort === 'pictures_first') view.sort(function (a, b) { return ((b.p || []).length ? 1 : 0) - ((a.p || []).length ? 1 : 0) || byDate(a, b); });
      else view.sort(byDate);
      cards = [];
      cols = [];
      shown = 0;
      peeking = true;
      lastCols = colCount();
      render(PER_PAGE);
    }

    function card(r) {
      var media = (r.p || []).map(function (p, i) {
        return '<button class="pfr-card__thumb" type="button" data-pi="' + i + '" aria-label="Open photo"><img src="' + esc(img(p[0], 160)) + '" alt="" loading="lazy" width="69" height="69"></button>';
      }).join('');
      var el = document.createElement('div');
      el.className = 'pfr-card';
      el.innerHTML =
        stars(r.r) +
        '<div class="pfr-card__who"><div class="pfr-card__name-row"><span class="pfr-card__name">' + esc(r.n) + '</span>' + verifiedTag(r.v) + '</div>' +
        '<span class="pfr-card__date">' + esc(r.d) + '</span></div>' +
        (r.t ? '<p class="pfr-card__title">' + esc(r.t) + '</p>' : '') +
        '<p class="pfr-card__body">' + esc(r.b) + '</p>' +
        '<button class="pfr-card__more" type="button" hidden>More</button>' +
        (r.v === 'shop' ? '<p class="pfr-card__note">Review written in Shop App</p>' : '') +
        (media ? '<div class="pfr-card__media">' + media + '</div>' : '');
      el.addEventListener('click', function (e) {
        var t = e.target.closest('.pfr-card__thumb');
        if (t) openModal(photosOf([r]), +t.getAttribute('data-pi'));
        if (e.target.closest('.pfr-card__more')) {
          el.querySelector('.pfr-card__body').classList.add('is-open');
          e.target.hidden = true;
        }
      });
      return el;
    }

    // Masonry like Judge.me: each new card goes under the shortest column
    var cols = [], cards = [];
    function colCount() {
      return Math.max(1, Math.min(4, Math.floor((grid.clientWidth + 24) / (260 + 24))));
    }
    function buildCols() {
      grid.innerHTML = '';
      cols = [];
      for (var i = 0, n = colCount(); i < n; i++) {
        var c = document.createElement('div');
        c.className = 'pfr-col';
        grid.appendChild(c);
        cols.push(c);
      }
      cards.forEach(place);
    }
    function place(card) {
      var best = cols[0];
      cols.forEach(function (c) { if (c.offsetHeight < best.offsetHeight) best = c; });
      best.appendChild(card);
    }

    function render(n) {
      if (!cols.length) buildCols();
      var added = [];
      view.slice(shown, shown + n).forEach(function (r) {
        var c = card(r);
        added.push(c);
        cards.push(c);
        place(c);
      });
      shown += added.length;
      // "More" only where the five-line clamp actually cut the text
      requestAnimationFrame(function () {
        added.forEach(function (c) {
          var b = c.querySelector('.pfr-card__body');
          if (b.scrollHeight > b.clientHeight + 2) c.querySelector('.pfr-card__more').hidden = false;
        });
        syncFooter();
      });
    }
    var lastCols = 0;
    window.addEventListener('resize', function () {
      if (colCount() !== lastCols) { lastCols = colCount(); buildCols(); }
    });

    function syncFooter() {
      // Judge.me only peeks when there are more reviews waiting behind the first page
      var tall = grid.scrollHeight > 560 && view.length > shown;
      body.classList.toggle('is-peek', peeking && tall);
      if (peeking && tall) {
        moreBtn.hidden = false;
        moreBtn.innerHTML = 'Show more ' + CHEV_D;
      } else {
        moreBtn.hidden = shown >= view.length;
        moreBtn.innerHTML = 'Load more reviews ' + CHEV_D;
      }
    }

    moreBtn.addEventListener('click', function () {
      if (peeking) { peeking = false; syncFooter(); return; }
      render(PER_PAGE);
    });

    var sortSel = root.querySelector('.pfr-sort select');
    sortSel.addEventListener('change', function () { sort = sortSel.value; apply(); });
    var toggle = root.querySelector('.pfr-filter-toggle'), panel = root.querySelector('.pfr-filters');
    toggle.addEventListener('click', function () {
      panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', panel.classList.contains('is-open'));
    });
    document.addEventListener('click', function (e) {
      if (panel.classList.contains('is-open') && !panel.contains(e.target) && !toggle.contains(e.target)) {
        panel.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---------- write a review (sends through the store's contact form) ---------- */
  function initForm(root) {
    var tpl = root.querySelector('template.pfr-form-tpl');
    if (!tpl) return;
    var box;
    root.addEventListener('click', function (e) {
      if (!e.target.closest('.pfr-btn--write')) return;
      if (!box) {
        box = document.createElement('div');
        box.className = 'pfr pfr-modal';
        box.innerHTML = '<div class="pfr-modal__box pfr-modal__box--form"><button class="pfr-modal__close" type="button" aria-label="Close">&times;</button></div>';
        box.firstChild.appendChild(tpl.content.cloneNode(true));
        document.body.appendChild(box);
        document.addEventListener('keydown', function (ev) {
          if (ev.key === 'Escape' && box.classList.contains('is-open')) { box.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
        });
        box.addEventListener('click', function (ev) {
          if (ev.target === box || ev.target.closest('.pfr-modal__close')) { box.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
          var star = ev.target.closest('.pfr-rate button');
          if (star) {
            var v = +star.getAttribute('data-v');
            box.querySelectorAll('.pfr-rate button').forEach(function (b) { b.classList.toggle('is-on', +b.getAttribute('data-v') <= v); });
            box.querySelector('input[name="contact[Rating]"]').value = v + ' stars';
          }
        });
      }
      box.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    });
    if (root.hasAttribute('data-posted')) {
      root.querySelector('.pfr-btn--write') && root.querySelector('.pfr-btn--write').click();
    }
  }

  /* ---------- "Real customer stories" carousel ---------- */
  function initStories(root) {
    var stage = root.querySelector('.pfr-stories__stage');
    var tiles = [], items = [], center = 0;
    fetchJSON(root.getAttribute('data-src')).then(function (data) {
      // one tile per photo, newest first, like the Judge.me carousel
      items = photosOf(data.reviews || []).slice(0, 20);
      if (!items.length) { root.hidden = true; return; }
      stage.innerHTML = items.map(function (it, i) {
        return '<button class="pfr-tile" type="button" data-i="' + i + '" aria-label="Review from ' + esc(it.review.n) + '">' +
          '<img src="' + esc(img(it.url, 520)) + '" alt="" loading="lazy">' +
          '<span class="pfr-tile__shade"></span><span class="pfr-tile__meta">' + stars(it.review.r) +
          '<span class="pfr-tile__name">' + esc(it.review.n) + (it.review.v ? CHECK : '') + '</span></span></button>';
      }).join('');
      tiles = [].slice.call(stage.querySelectorAll('.pfr-tile'));
      // start with the newest photo at the far left, as the Judge.me carousel did
      center = Math.min(window.innerWidth < 768 ? 1 : 2, tiles.length - 1);
      layout();
    }).catch(function () { root.hidden = true; });

    function layout() {
      var narrow = window.innerWidth < 768;
      var gap = narrow ? 190 : 210, side = narrow ? 1 : 2;
      tiles.forEach(function (t, i) {
        var d = i - center, n = tiles.length;
        if (d > n / 2) d -= n;
        if (d < -n / 2) d += n;
        var visible = Math.abs(d) <= side;
        t.classList.toggle('is-center', d === 0);
        t.style.opacity = visible ? 1 : 0;
        t.style.pointerEvents = visible ? '' : 'none';
        t.style.transform = 'translate(calc(-50% + ' + d * gap + 'px), -50%)';
        t.style.zIndex = 3 - Math.abs(d);
        t.tabIndex = visible ? 0 : -1;
      });
    }
    stage.addEventListener('click', function (e) {
      var t = e.target.closest('.pfr-tile');
      if (!t) return;
      var i = +t.getAttribute('data-i');
      if (i === center) openModal(items, i);
      else { center = i; layout(); }
    });
    root.querySelector('.pfr-stories__prev').addEventListener('click', function () { center = (center - 1 + tiles.length) % tiles.length; layout(); });
    root.querySelector('.pfr-stories__next').addEventListener('click', function () { center = (center + 1) % tiles.length; layout(); });
    window.addEventListener('resize', layout);
    var x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { center = (center + (dx < 0 ? 1 : -1) + tiles.length) % tiles.length; layout(); }
      x0 = null;
    });
  }

  /* ---------- badge: tap to jump to the reviews ---------- */
  function initBadges() {
    document.querySelectorAll('[data-pfr-badge]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        var target = document.querySelector('.pfr-widget');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function boot() {
    document.querySelectorAll('.pfr-widget[data-src]').forEach(function (w) { initWidget(w); initForm(w); });
    document.querySelectorAll('.pfr-widget--empty').forEach(initForm);
    document.querySelectorAll('.pfr-stories[data-src]').forEach(initStories);
    initBadges();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
